import React from 'react'
import {Minus, Plus} from 'lucide-react'
import { cn } from '../../lib/utils'

interface StepperProps {
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  label?: string
  className?: string
}

export function Stepper({ value, onChange, min = 1, max = 20, label, className }: StepperProps) {
  const handleDecrement = () => {
    if (value > min) onChange(value - 1)
  }

  const handleIncrement = () => {
    if (value < max) onChange(value + 1)
  }

  return (
    <div className={cn("space-y-2", className)}>
      {label && (
        <label className="block text-sm font-medium text-gray-700">{label}</label>
      )}
      <div className="flex items-center space-x-4">
        <button
          type="button"
          onClick={handleDecrement}
          disabled={value <= min}
          className="w-12 h-12 rounded-full border-2 border-red-600 text-red-600 flex items-center justify-center hover:bg-red-50 disabled:opacity-30 disabled:cursor-not-allowed transition-all active:scale-95"
        >
          <Minus className="h-5 w-5" />
        </button>
        
        <div className="flex-1 text-center">
          <div className="text-4xl font-black text-gray-900">{value}</div>
          <div className="text-xs text-gray-500 mt-1">
            {value === 1 ? 'unidade' : 'unidades'}
          </div>
        </div>

        <button
          type="button"
          onClick={handleIncrement}
          disabled={value >= max}
          className="w-12 h-12 rounded-full bg-red-600 text-white flex items-center justify-center hover:bg-red-700 disabled:opacity-30 disabled:cursor-not-allowed transition-all active:scale-95"
        >
          <Plus className="h-5 w-5" />
        </button>
      </div>
      <div className="text-center text-xs text-gray-500">
        Mínimo: {min} • Máximo: {max}
      </div>
    </div>
  )
}
